import { ShaderMaterial, Vector2 } from 'three'

const vertexShader = /*glsl*/ `
    varying vec2 vUv;

    void main() {
        vUv = uv;
        gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }
`

const fragmentShader = /*glsl*/ `
    float rand(vec2 n) { 
        return fract(sin(dot(n, vec2(12.9898, 4.1414))) * 43758.5453);
    }

    varying vec2 vUv;
    uniform sampler2D uTexture;
    uniform sampler2D uDepthTexture;
    uniform vec2 uOffset;
    uniform float uAppear;

    void main() {
        vec4 depth = texture2D(uDepthTexture, vUv);

        // float distanceToCenter = 1. - distance(vUv, vec2(0.5));

        // float rgbOffset = distanceToCenter;
        // float rgbOffset = depth.r;
        float rgbOffset = 1.;

        float r = texture2D(uTexture, vUv + vec2(-0.003 * rgbOffset) + (depth.r * uOffset)).r;
        float g = texture2D(uTexture, vUv + (depth.r * uOffset)).g;
        float b = texture2D(uTexture, vUv + vec2(0.003 * rgbOffset) + (depth.r * uOffset)).b;
        vec3 color = vec3(r, g, b);

        float noise = rand(vUv);
        color -= noise * 0.08;
        
        // vec4 color = texture2D(uTexture, vUv + depth.r * uOffset);

        vec3 originalColor = texture2D(uTexture, vUv).rgb;
        
        gl_FragColor = vec4( mix(originalColor, color, uAppear) , 1.);
    }
`

export class DepthMaterial extends ShaderMaterial {
  constructor() {
    super({
      vertexShader,
      fragmentShader,
      uniforms: {
        uTexture: { value: null },
        uDepthTexture: { value: null },
        uOffset: { value: new Vector2(0, 0) },
        uAppear: {
          value: 0,
        },
      },
      transparent: true,
    })

    this.offset = this.uniforms.uOffset.value
  }

  set texture(value) {
    this.uniforms.uTexture.value = value
  }

  set depthTexture(value) {
    this.uniforms.uDepthTexture.value = value
  }
}
